export default __webpack_public_path__ + "static/banner-the-ins-and-outs-of-managing-your-household-budget-b2a06a7ce28531239d4e7e3dde6f221c.webp";